export default "__VITE_ASSET__oPNqn63W__"